/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_Saves_OneInputs */

const en_bell_activity_saves_one = /** @type {(inputs: Bell_Activity_Saves_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 save`)
};

/**
* | output |
* | --- |
* | "1 save" |
*
* @param {Bell_Activity_Saves_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_saves_one = /** @type {((inputs?: Bell_Activity_Saves_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Saves_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_saves_one(inputs)
});